<!-- eslint-disable max-len -->
<template>
  <div>
    <Card
      title="Subscription Price"
    >
      <template v-slot:button>
        <Button @clicked="isShowingModalAdd = true;this.input.lowest_price = 2" label="Add Subscription Price" variant="primary"/>
      </template>
      <template v-slot:body>
        <data-tables-server ref="tableTransaction" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [displayingItem] }" @query-change="onChangeTable" >
          <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
          </el-table-column>
          <el-table-column label="Actions" align="right" min-width="100px">
            <template slot-scope="scope">
              <div class="static inline-block text-left container-action">
                <VueCustomTooltip label="Edit" :position="'is-left'">
                  <button @click="update = scope.row; isShowingModalEdit = true" class="p-2 mr-2 rounded bg-yellow-500 hover:bg-yellow-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'pencil-alt']" />
                  </button>
                </VueCustomTooltip>
                <VueCustomTooltip label="Delete" :position="'is-left'">
                  <button  @click="submitDelete(scope.row)"  class="p-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'trash-alt']" />
                  </button>
                </VueCustomTooltip>
              </div>
            </template>
          </el-table-column>
        </data-tables-server>
      </template>
    </Card>
    <ModalDialog
      :isShowingModal="isShowingModalAdd"
      :isLoading="isLoading"
      title="Add Subscription Price"
      :labelSubmit="'Add'"
      @toggleModal="isShowingModalAdd=!isShowingModalAdd"
      @save="submitAdd()" >
      <template slot="body" >
        <form class="flex w-full overflow-y-auto overflow-x-hidden" id="form-activity" autocomplete="off" >
          <div class="w-full p-2" >
            <form-item label='Country'>
              <el-select v-model="input.country" filterable placeholder="Select Country" class="w-full">
                <el-option
                  v-for="item in listCountry"
                  :key="item.code"
                  :label="item.code+' - '+item.name"
                  :value="item.code">
                </el-option>
              </el-select>
              <div class="flex flex-col pt-2" v-if="$v.input.country.$dirty">
                <text-error v-if="!$v.input.country.required" text="Please fill Country." />
              </div>
            </form-item>
            <form-item label='Currency'>
              <el-select v-model="input.currency" filterable placeholder="Select Currency" class="w-full">
                <el-option
                  v-for="item in dataCurrencies"
                  :key="item.id"
                  :label="item.id+' - '+item.label"
                  :value="item.id">
                </el-option>
              </el-select>
              <div class="flex flex-col pt-2" v-if="$v.input.currency.$dirty">
                <text-error v-if="!$v.input.currency.required" text="Please fill Currency." />
              </div>
            </form-item>
            <form-item label='Type'>
              <el-select v-model="input.currency" filterable placeholder="Select Type" class="w-full">
                <el-option
                  v-for="item in dataType"
                  :key="item.id"
                  :label="item.id+' - '+item.label"
                  :value="item.id">
                </el-option>
              </el-select>
              <div class="flex flex-col pt-2" v-if="$v.input.type.$dirty">
                <text-error v-if="!$v.input.type.required" text="Please fill type." />
              </div>
            </form-item>
            <form-item label='Price'>
              <Input
                v-model="input.price"
                placeholder="Price"
                :error="$v.input.price.$dirty && (!$v.input.price.required || !$v.input.price.decimal || !$v.input.price.minValue)"
                maxlength="100"
              />
              <div class="flex flex-col pt-2" v-if="$v.input.price.$dirty">
                <text-error v-if="!$v.input.price.required" text="Please fill Price." />
                <text-error v-if="!$v.input.price.decimal" text="Please input numeric value." />
                <text-error v-if="!$v.input.price.minValue" text="Please input greater than 0." />
              </div>
            </form-item>
            <form-item label='Lowest Price'>
              <Input
                v-model="input.lowest_price"
                placeholder="Lowest Price"
                :error="$v.input.lowest_price.$dirty && (!$v.input.lowest_price.required || !$v.input.lowest_price.decimal || !$v.input.lowest_price.minValue)"
                maxlength="100"
              />
              <div class="flex flex-col pt-2" v-if="$v.input.lowest_price.$dirty">
                <text-error v-if="!$v.input.lowest_price.required" text="Please fill Lowest Price." />
                <text-error v-if="!$v.input.lowest_price.decimal" text="Please input numeric value." />
                <text-error v-if="!$v.input.lowest_price.minValue" text="Please input greater than 0." />
              </div>
            </form-item>
          </div>
        </form>
      </template>
    </ModalDialog>
    <ModalDialog
      :isShowingModal="isShowingModalEdit"
      :isLoading="isLoading"
      title="Edit Subscription Price"
      :labelSubmit="'Save'"
      @toggleModal="isShowingModalEdit=!isShowingModalEdit"
      @save="submitEdit()" >
      <template slot="body" >
        <form class="flex w-full overflow-y-auto overflow-x-hidden" id="form-activity-edit" autocomplete="off" >
          <div class="w-full p-2" >
            <form-item label='Country'>
              <el-select v-model="update.country" filterable placeholder="Select Country" class="w-full">
                <el-option
                  v-for="item in listCountry"
                  :key="item.code"
                  :label="item.code+' - '+item.name"
                  :value="item.code">
                </el-option>
              </el-select>
              <div class="flex flex-col pt-2" v-if="$v.update.country.$dirty">
                <text-error v-if="!$v.update.country.required" text="Please fill Country." />
              </div>
            </form-item>
            <form-item label='Currency'>
              <el-select v-model="update.currency" filterable placeholder="Select Currency" class="w-full">
                <el-option
                  v-for="item in dataCurrencies"
                  :key="item.id"
                  :label="item.id+' - '+item.label"
                  :value="item.id">
                </el-option>
              </el-select>
              <div class="flex flex-col pt-2" v-if="$v.update.currency.$dirty">
                <text-error v-if="!$v.update.currency.required" text="Please fill Currency." />
              </div>
            </form-item>
            <form-item label='Type'>
              <el-select v-model="update.currency" filterable placeholder="Select Type" class="w-full">
                <el-option
                  v-for="item in dataType"
                  :key="item.id"
                  :label="item.id+' - '+item.label"
                  :value="item.id">
                </el-option>
              </el-select>
              <div class="flex flex-col pt-2" v-if="$v.update.type.$dirty">
                <text-error v-if="!$v.update.type.required" text="Please fill type." />
              </div>
            </form-item>
            <form-item label='Price'>
              <Input
                v-model="update.price"
                placeholder="Price"
                :error="$v.update.price.$dirty && (!$v.update.price.required || !$v.update.price.decimal || !$v.update.price.minValue)"
                maxlength="100"
              />
              <div class="flex flex-col pt-2" v-if="$v.update.price.$dirty">
                <text-error v-if="!$v.update.price.required" text="Please fill Price." />
                <text-error v-if="!$v.update.price.decimal" text="Please input numeric value." />
                <text-error v-if="!$v.update.price.minValue" text="Please input greater than 0." />
              </div>
            </form-item>
            <form-item label='Lowest Price'>
              <Input
                v-model="update.lowest_price"
                placeholder="Lowest Price"
                :error="$v.update.lowest_price.$dirty && (!$v.update.lowest_price.required || !$v.update.lowest_price.decimal || !$v.update.lowest_price.minValue)"
                maxlength="100"
              />
              <div class="flex flex-col pt-2" v-if="$v.update.lowest_price.$dirty">
                <text-error v-if="!$v.update.lowest_price.required" text="Please fill Lowest Price." />
                <text-error v-if="!$v.update.lowest_price.decimal" text="Please input numeric value." />
                <text-error v-if="!$v.update.lowest_price.minValue" text="Please input greater than 0." />
              </div>
            </form-item>
          </div>
        </form>
      </template>
    </ModalDialog>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import ModalDialog from '@/components/Common/ModalDialog';
import InputAutoComplete from '@/components/Common/InputAutoComplete';
import moment from 'moment';
import { validationMixin } from 'vuelidate';
import { required, decimal } from 'vuelidate/lib/validators';
import helpersMixins from '../mixins/helpers.mixins';
import Card from '@/components/Layout/Card.vue';
import { Button, FormItem, Input, Select, TextArea, TextError } from '@/components/Layout/Form';

const displayingItems = 50;

export default {
  name: 'SubscriptionSettingPage',
  mixins: [validationMixin, helpersMixins],
  data() {
    return {
      isLoading: false,
      isShowingModalAdd: false,
      isShowingModalEdit: false,
      utc_offset: Math.floor(moment().utcOffset() / 60),
      data: [],
      dataCountries: [],
      dataCurrencies: [],
      dataType: [
        {
          id: 1,
          label: 'Individual',
        }, {
          id: 2,
          label: 'Student',
        },
      ],
      total: 0,
      displayingItem: displayingItems,
      titles: [{
        prop: 'country_name',
        label: 'Country',
      }, {
        prop: 'type_text',
        label: 'Type',
      }, {
        prop: 'date',
        label: 'Date',
      }, {
        prop: 'currency',
        label: 'Currency',
      }, {
        prop: 'price_text',
        label: 'Price',
      }, {
        prop: 'lowest_price',
        label: 'Lowest Price',
      }],
      filter: {
        page: 1,
        per_page: displayingItems,
        q: '',
        sortby: 'country',
        sortorder: 'desc',
      },
      input: {
        country: '',
        currency: '',
        type: '',
        price: 0,
        lowest_price: 2,
      },
      update: {
        id: '',
        country: '',
        currency: '',
        type: '',
        price: 0,
        lowest_price: 2,
      },
    };
  },
  validations() {
    let rules = {
      input: {
        country: {},
        currency: {},
        type: {},
        price: {},
        lowest_price: {},
      },
      update: {
        country: {},
        currency: {},
        type: {},
        price: {},
        lowest_price: {},
      },
    };

    if (this.isShowingModalAdd) {
      rules = Object.assign(rules, {
        input: {
          country: {
            required,
          },
          currency: {
            required,
          },
          type: {
            required,
          },
          price: {
            required,
            decimal,
            minValue: this.greaterThanZero,
          },
          lowest_price: {
            required,
            decimal,
            minValue: this.greaterThanZero,
          },
        },
      });
    }

    if (this.isShowingModalEdit) {
      rules = Object.assign(rules, {
        update: {
          country: {
            required,
          },
          currency: {
            required,
          },
          type: {
            required,
          },
          price: {
            required,
            decimal,
            minValue: this.greaterThanZero,
          },
          lowest_price: {
            required,
            decimal,
            minValue: this.greaterThanZero,
          },
        },
      });
    }
    return rules;
  },
  async mounted() {
    this.toggleDashboardProfile(false);
    await this.requestListSubscription(this.filter);
    await this.requestListCountry();
    this.dataCountries = this.getCountries();
    this.dataCurrencies = this.getCurrencies();
  },
  computed: {
    ...mapGetters('SubscriptionModule', ['list_subscription']),
    ...mapGetters('AppSettingModule', ['listCountry']),
    ...mapGetters('NotificationModule', ['getMessage']),
  },
  watch: {
    list_subscription: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (this.list_subscription.data !== undefined) {
          this.data = this.list_subscription.data.data.map(subs => ({ ...subs,
            date: moment(subs.created_at).format('YYYY-MM-DD HH:mm:ss'),
            type_text: subs.type === 1 ? 'Individual' : 'Student',
            price_text: subs.price ? this.formatPrice(subs.price) : 0,
          }));
          this.total = this.list_subscription.data.total;
        }
      },
    },
  },
  methods: {
    ...mapActions('SubscriptionModule', ['requestListSubscription', 'requestAddSubscriptionPrice',
      'requestEditSubscriptionPrice', 'requestDeleteSubscriptionPrice']),
    ...mapActions('AppSettingModule', ['requestListCountry']),
    async search() {
      await this.requestListSubscription(this.filter);
    },
    moment(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    async reset() {
      this.$refs.tableTransaction.$refs.elTable.clearSort();
      this.filter = {
        page: 1,
        per_page: this.displayingItem,
        sortby: 'id',
        sortorder: 'desc',
        q: '',
      };
      this.search();
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const pageSize = queryInfo.pageSize;
      this.displayingItem = pageSize;
      const page = queryInfo.page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'id';
      }
      sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      this.filter = Object.assign(this.filter, { per_page: this.displayingItem, sortorder, sortby, page });
      await this.requestListSubscription(this.filter);
    },
    async submitAdd() {
      try {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          const data = {
            type: this.input.type,
            price: this.input.price,
            currency: this.input.currency,
            country: this.input.country,
            lowest_price: this.input.lowest_price,
          };
          await this.requestAddSubscriptionPrice({ data, filter: this.filter });
          this.isShowingModalAdd = false;
          this.$v.$reset();
          this.input = { type: '', price: 0, lowest_price: 2, country: '', currency: '' };
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    },
    async submitEdit() {
      try {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          const data = {
            id: this.update.id,
            type: this.update.type,
            price: this.update.price,
            currency: this.update.currency,
            country: this.update.country,
            lowest_price: this.update.lowest_price,
          };
          await this.requestEditSubscriptionPrice({ data, filter: this.filter });
          this.isShowingModalEdit = false;
          this.$v.$reset();
          this.update = { id: '', type: '', price: 0, lowest_price: 0, country: '', currency: '' };
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    },
    async submitDelete(row) {
      Vue.swal({
        title: 'Delete Data!',
        text: 'Are you sure to delete subscription price?',
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          await this.requestDeleteSubscriptionPrice({ data: { id: row.id }, filter: this.filter });
          this.$swal('Deleted', 'You successfully subscription price', 'success');
        }
      });
    },

  },
  components: {
    VueCustomTooltip, ModalDialog, InputAutoComplete,
    Card,
    Button,
    FormItem, Input, TextArea, TextError, Select
  },
};
</script>
<style>
.daterangepicker .calendars{
  display:flex !important;
}
</style>
<style scoped>
.z-1000{
  z-index: 1000;
}
.mx-400{
  max-height: 50%;
  height: 50vh;
}
</style>



// WEBPACK FOOTER //
// src/views/SubscriptionSetting.vue